import { DO_NOT_USE_FaWrapper } from '../../../v2/foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { useCalendar } from '../../Context.js';
import { jsx } from 'react/jsx-runtime';
import { Button } from '../../../v2/navigation/buttons/Button/Button.js';

function CloseYearPickerButton() {
  var _useCalendar = useCalendar(),
    yearPickerVisible = _useCalendar.yearPickerVisible,
    hideYearPicker = _useCalendar.hideYearPicker;
  if (!yearPickerVisible) {
    return null;
  }
  return /*#__PURE__*/jsx(Button, {
    appearance: "ghost",
    type: "button",
    onClick: hideYearPicker,
    size: "small",
    children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
      icon: faXmark
    })
  });
}

export { CloseYearPickerButton };
